import { useMemo } from "react";
import { useNavigate, useLocation } from "react-router";

import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { canDeleteDeployment } from "shared/Templates/access/canDeleteDeployment";
import { canUpdateTemplateDeployment } from "shared/Templates/access/canUpdateTemplateDeployment";
import { TemplateDeployment } from "types/generated";

import { TemplateContext } from "../../../Context";
import { showDeleteConfirmation } from "../../DeleteConfirmation";

const TemplateDeploymentsRowActionsCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<TemplateDeployment>) => {
  const { template: templateData } = useTypedContext(TemplateContext);
  const navigate = useNavigate();
  const location = useLocation();

  const updateDeploymentAccess = canUpdateTemplateDeployment(deployment);
  const menuItems = useMemo(() => {
    const items = [];

    items.push(
      <DropdownMenuItem
        key="update-deployment"
        onAction={() =>
          navigate(
            `/template/${templateData.id}/version/${deployment.templateVersion.id}/deployments/${deployment.id}/update`,
            { state: { returnUrl: location.pathname } }
          )
        }
        isDisabled={!updateDeploymentAccess.result}
        tooltip={updateDeploymentAccess.message}
      >
        Update deployment
      </DropdownMenuItem>
    );
    const deleteAccess = canDeleteDeployment(deployment);
    items.push(
      <DropdownMenuItem
        key="delete"
        onAction={() =>
          showDeleteConfirmation({
            name: deployment.name,
            id: deployment.id,
            templateID: templateData.id,
          })
        }
        danger
        isDisabled={!deleteAccess.result}
        tooltip={deleteAccess.message}
      >
        Delete
      </DropdownMenuItem>
    );

    return items;
  }, [updateDeploymentAccess, deployment, templateData, navigate, location.pathname]);

  return (
    <TableSimpleCell {...cellProps}>
      {menuItems.length > 0 && (
        <DropdownMenuEllipsis tooltip="Deployment actions">{menuItems}</DropdownMenuEllipsis>
      )}
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsRowActionsCell;
